import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "dbc3c4fc-ccc9-4087-a061-b5e68c4647e7", // React app's App ID
    authority: "https://login.microsoftonline.com/5c1f1620-2fa8-46e0-b7f6-be5a8531bf36", // Client's tenant ID
    redirectUri: "https://friday.oneemcure.ai", // must exactly match registered URI
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

let msalInstance = null;

export const loginRequest = {
scopes: ["dbc3c4fc-ccc9-4087-a061-b5e68c4647e7/.default", "openid", "profile", "offline_access"],
};

export const databricksRequest = {
  scopes: ["2ff814a6-3304-4ab8-85cb-cd0e6f879c1d/.default"],
};

export function getMsalInstance() {
  if (!msalInstance) {
    if (typeof window === "undefined" || !window.crypto) {
      throw new Error("MSAL cannot be initialized: crypto not available");
    }
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
}

export async function getAppAccessToken(account) {
  try {
    const response = await getMsalInstance().acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    throw error;
  }
}

export async function getDatabricksToken(account) {
  try {
    const response = await getMsalInstance().acquireTokenSilent({
      ...databricksRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    throw error;
  }
}

export async function getAllTokens(account) {
  try {
    const appResponse = await getMsalInstance().acquireTokenSilent({
      ...loginRequest,
      account,
    });
    const appToken = appResponse.accessToken;
    const appExpiresOn = appResponse.expiresOn ? appResponse.expiresOn.getTime() : null;

    let databricksToken = null;
    let databricksExpiresOn = null;
    try {
      const dbResponse = await getMsalInstance().acquireTokenSilent({
        ...databricksRequest,
        account,
      });
      databricksToken = dbResponse.accessToken;
      databricksExpiresOn = dbResponse.expiresOn ? dbResponse.expiresOn.getTime() : null;
    } catch (error) {
      // Databricks token is optional; continue with app token only.
    }

    return {
      appToken,
      databricksToken,
      appExpiresOn,
      databricksExpiresOn,
    };
  } catch (error) {
    throw error;
  }
}

export async function logout() {
  try {
    const msalInstance = getMsalInstance();
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  } catch (error) {
    throw error;
  }
}
